import React, { Component } from 'react';
import './FlipdataContent.css';
import { toUpper, shrinkWordsWidth } from '../../library/calc';


class FlipDataContent extends Component {

  getUserNamedFacts(){

    const { attrs } = this.props.flipData;

    if(typeof(attrs) !== 'undefined' && typeof(attrs.user_named_facts) !== 'undefined' ){
      const { user_named_facts } = attrs;
      let label = undefined;
      let content = undefined;
      let user_named_facts_array = [];
      for( let key in user_named_facts){
        label = key;
        content = user_named_facts[key];
        user_named_facts_array.push({label, content})
      }

      return {
        exist: true,
        user_named_facts_array
      }
    } else {
      return {exist: false};
    }

  }

  showUserNamedFactsTR({userNamedFacts, boldStyle}){
    const tableRows = userNamedFacts.user_named_facts_array.map((userNamedFact)=>{
      return <tr>
                <td className='isLabel' style={boldStyle}>{`${userNamedFact.label}`}:
                </td>
                <td dangerouslySetInnerHTML={{__html: userNamedFact.content}} />
              </tr>
    })

    return tableRows;
  }

  getExtraData(){

    const { attrs } = this.props.flipData;

    if(typeof(attrs) !== 'undefined' && typeof(attrs.extra_data) !== 'undefined' ){
      const { extra_data } = attrs;
      let label = undefined;
      let content = undefined;
      for( let key in extra_data){
        label = key;
        content = extra_data[key];
      }

      return {
        exist: true,
        label,
        content,
      }
    } else {
      return {exist: false};
    }

  }

  render () {

    const { translatedLabels } = this.props;

    const maxLength = 20;
    this.birthLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Birth'].translatedLabel), maxLength});
    this.deathLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Death'].translatedLabel), maxLength});
    this.occupationLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Occupation'].translatedLabel), maxLength});
    this.locationLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Location'].translatedLabel), maxLength});
    this.aboutLabel = shrinkWordsWidth({word: toUpper(translatedLabels['About'].translatedLabel), maxLength});
    this.joinedLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Joined'].translatedLabel), maxLength});
    this.curatorLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Curator'].translatedLabel), maxLength});
    this.privateProfileLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Private Profile'].translatedLabel), maxLength});
    this.profileHistoryLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Profile History'].translatedLabel), maxLength});
    this.updatedByLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Updated by'].translatedLabel), maxLength});
    this.addedByLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Added by'].translatedLabel), maxLength});
    this.dnaMarkersLabel = shrinkWordsWidth({word: toUpper(translatedLabels['DNA markers'].translatedLabel), maxLength});
    this.managedByLabel = shrinkWordsWidth({word: toUpper(translatedLabels['Managed by'].translatedLabel), maxLength});

    const boldStyle = {fontWeight:'bold'};
    const { flipData }  = this.props;
    const { display } = flipData;
    const userNamedFacts = this.getUserNamedFacts();
    const extraData = this.getExtraData();


// console.log(`flipData: `, JSON.stringify(flipData, null, 2));
// console.log(`typeof(display.about): `, typeof(display.about));
// console.log(`display.about: `, display.about);
// console.log(`typeof(display.about): `, typeof(display.about));
// console.log(`display.about: `, display.about);


    return (
      <table id="FlipdataContent">
        <tbody>


          {

            display.birth

            ?

              <tr>
                <td className='isLabel' style={boldStyle}>{`${this.birthLabel}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: flipData.attrs.birth}}/>
              </tr>
            :

            null

          }


          {

            display.death

            ?

              <tr>
                <td className='isLabel' style={boldStyle}>{`${this.deathLabel}`}:&nbsp;&nbsp;
                </td>
                <td
                  dangerouslySetInnerHTML={{__html: flipData.attrs.death}}
                />
              </tr>

            :

            null

          }

          {

            display.occupation

            ?

              <tr>
                <td className='isLabel' style={boldStyle}>{`${this.occupationLabel}`}:&nbsp;&nbsp;
                </td>
                <td
                  dangerouslySetInnerHTML={{__html: flipData.attrs.occupation}}
                />
              </tr>

            :

            null

          }


          {

            userNamedFacts.exist

            ?

                this.showUserNamedFactsTR({userNamedFacts, boldStyle})

            :

            null

          }

          {

            display.location

            ?

              <tr>
                <td className='isLabel' style={boldStyle}>{`${this.locationLabel}`}:&nbsp;&nbsp;
                </td>
                <td
                  dangerouslySetInnerHTML={{__html: flipData.attrs.location}}
                />
              </tr>

            :

            null

          }
          {

            display.dna_markers

            ?

              <tr>
                <td className='isLabel' style={boldStyle}>{`${this.dnaMarkersLabel}`}:&nbsp;&nbsp;
                </td>
                <td colSpan="0" dangerouslySetInnerHTML={{__html: flipData.attrs.dna_markers}} />
              </tr>

            :

            null

          }
          {

            display.private_profile

            ?

              <tr>
                <td className='isLabel' style={boldStyle}>{`${this.privateProfileLabel}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: flipData.attrs.private_profile}}/>
              </tr>

            :

            null

          }
{/*
          {

            display.about

            ?

              <tr>
                <td colSpan="2" dangerouslySetInnerHTML={{__html: flipData.attrs.about_me_summary}} />
              </tr>


            :

            null

          }
*/}


          {

            display.about

            ?

              <tr>
                <td className='isLabel' style={boldStyle}>{`${this.aboutLabel}`}:&nbsp;&nbsp;
                </td>
                <td
                  dangerouslySetInnerHTML={{__html: flipData.attrs.about_me_summary}}
                />
              </tr>

            :

            null

          }
          {

            extraData.exist

            ?

              <tr>
                <td className='isLabel'  style={boldStyle}>{`${extraData.label}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: extraData.content}} />
              </tr>
            :

            null

          }

          <tr>
            <td colSpan="2">&nbsp;
            </td>
          </tr>


          {

            display.profile

            ?

              <tr>
                <td className='isLabel' colSpan="2"  style={boldStyle}>{`${this.profileHistoryLabel}`}:&nbsp;&nbsp;
                </td>
              </tr>
            :

            null

          }


          {

            display.profile

            ?

              <tr>
                <td className='isLabel'>{`${this.updatedByLabel}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: flipData.attrs.last_updated_info}} />
              </tr>
            :

            null

          }


          {

            display.added_info

            ?

              <tr>
                <td className='isLabel'>{`${this.addedByLabel}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: flipData.attrs.added_info}} />
              </tr>
            :

            null

          }


          {

            display.joined_info

            ?

              <tr>
                <td className='isLabel'>{`${this.joinedLabel}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: flipData.attrs.joined_info}} />
              </tr>
            :

            null

          }


          {

            display.manager_info

            ?

              <tr>
                <td className='isLabel'>{`${this.managedByLabel}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: flipData.attrs.manager_info}} />
              </tr>
            :

            null

          }


          {

            display.curator_info

            ?

              <tr>
                <td className='isLabel'>{`${this.curatorLabel}`}:&nbsp;&nbsp;
                </td>
                <td dangerouslySetInnerHTML={{__html: flipData.attrs.curator_info}} />
              </tr>
            :

            null

          }


        </tbody>
      </table>
    );
  }
}

export default FlipDataContent;

